import React, { Component } from 'react';
import { getSysFieldid } from '@platform/api';
import { Item, ItemProvider } from '@platform/template';
import { DEFAULT_COLOR } from '../../../utils/index';

const suffix = 'expanded-form-';

@ItemProvider
class ExpandedForm extends Component {
    componentDidMount() {
        let { store, rowKey } = this.props;
        store.getInstance().register(`${suffix}${rowKey}`, this);
    }

    render () {
        let { items, layout } = this.props;

        return <div className="card-table-expanded-row">
            {items.map(item => {
                let {
                    color,
                    colnum = 1,
                } = item;
            
                // 浏览态全展开的label颜色
                color = DEFAULT_COLOR.has(color) ? '' : color;
            
                return (
                    <div
                        fieldid={getSysFieldid(item.attrcode)}
                        className="expanded-row-item"
                        key={item.attrcode}
                        style={{ width: `${colnum * layout.width}%` }}
                    >
                        <div style={{ color }} className="expanded-row-item-label">
                            {`${item.label}:`}
                        </div>
                        <div className="expanded-row-item-control">
                            {this.renderItem(item)}
                        </div>
                    </div>
                );
            })}
        </div>;
    }

    componentWillUnmount() {
        let { store, rowKey } = this.props;
        store.getInstance().register(`${suffix}${rowKey}`, this);
    }

    renderItem = item => {
        let { values, store, rowKey } = this.props,
            { itemtype, attrcode } = item;
        if (itemtype === "attachment") {
            return <Item
                {...item}
                browse={false}
                setFieldValue={({ value }) => {
                    store.setCellValue(rowKey, attrcode, { value });
                    store.forceUpdate();
                }}
                getFieldValue={() => store.getCellValue(rowKey, attrcode)}
                path={[rowKey, attrcode]}
            />;
        } else {
            let cellValue = values[attrcode];
            if(!cellValue?._display_ && ![undefined, null, ''].includes(cellValue?.value)) {
                cellValue = store.getInstance()._formatCellValue(values, attrcode, itemtype);
            }
            return cellValue?._display_;
        }
    }
}

export default ExpandedForm;